module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/basic_information_icon-d06efba407791d498371f767e31d091e.png";